import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { FirebaseService, httpService } from '@flexo/general';
import { useDispatch } from 'react-redux';
import { METADATA, USER, ALERT } from '@flexo/reducers';

const ENV = (import.meta as any).env;

const firebaseService = new FirebaseService();


export const CommunitiesResolver = React.memo((props: any) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();

  async function init() {
    const idToken = await firebaseService.getIdToken();

    if (!idToken) {
      dispatch(ALERT.SetAlert({
        value: {
          type: 'BANNER_SESSION_EXPIRED'
        },
      } as any));

      dispatch(USER.SetLogout());

      return;
    }

    const [communities] = await Promise.all([
      httpService.get({
        url: `${ENV.VITE_APP_BASE_URL}/hive/api/catalog/v1_3/organization/${ENV.VITE_APP_ORG_ID}/communities`,
        idToken,
      })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data.communities;
          } else {

            dispatch(ALERT.SetAlert({
              value: {
                type: 'BANNER_UNEXPECTED_ERROR'
              },
            } as any));

            return null;
          }
        })
        .catch((err: any) => {

          dispatch(ALERT.SetAlert({
            value: {
              type: 'BANNER_UNEXPECTED_ERROR'
            },
          } as any));

          return null;
        }),
    ]);

    dispatch(METADATA.SetCommunities(communities) as any);

  }


  useEffect(() => {
    init();
  }, []);

  return <></>;

});